export default __webpack_public_path__ + "assets/images/g-box-bg-0ed1236d.jpg";